import React from 'react';
import { IconDescription } from '@noths/polaris-client-ribbons-design-system';
import { Link } from '@noths/polaris-dev-ts-types';

import * as styles from './styles';

export type FileLinkProps = Link;

export const FileLink = ({ title, href }: FileLinkProps) => (
  <div css={[styles.fileLinkWrapper]}>
    <IconDescription css={styles.fileIcon} width={16} height={16} />
    <a css={styles.fileLink} href={href!} rel="noreferrer" target="_blank">
      {title}
    </a>
  </div>
);
